import { Injectable } from "@angular/core";
import { DropdownSettingsFactory } from "../dropdown/dropdown-settings.factory";
import { OwnerService } from "../../../services/billing-letter/owner.service";
import { OptionsBilling } from "../../enums/billing-letter/OptionsBilling";
import { DropdownItemFactory } from "../dropdown/dropdown-item.factory";
import { CompaniesService } from "../../../services/companies.service";
import { LocalStorage } from "../../wrappers/LocalStorage";
import { CommonHelper } from "../../helpers/CommonHelper";
import { FiltersFactory } from "../filters.factory";
import { ConsultantService } from "../../../services/consultant.service";
import { ConsultantSearch } from "../../../models/ConsultantSearch.model";
import { UserService } from "../../../services/user.service";
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { IndustriesService } from '../../../services/industries.service';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';

@Injectable()
export class CostFiltersFactory extends FiltersFactory {
    constructor(private localStorage: LocalStorage,
        private ownerService: OwnerService,
        private commonHelper: CommonHelper,
        private optionsBilling: OptionsBilling,
        private companiesService: CompaniesService,
        private dropdownItemFactory: DropdownItemFactory,
        private dropdownSettingFactory: DropdownSettingsFactory,
        private consultantService: ConsultantService,
        private projectsFinancialService: ProjectFinancialService,
        private userService: UserService,
        private industriesService: IndustriesService,
        private excellenceCentersService: ExcellenceCentersService
    ) { super() }

    async build(filters, localStorageFilterKey = 'cost') {

        filters.companies.list = this.dropdownItemFactory.build({ source: await this.companiesService.listAllWithBillings() });
        filters.owners.list = this.dropdownItemFactory.build({ source: await this.ownerService.getAll() });
        filters.subDivision.list = this.dropdownItemFactory.build({ source: await this.projectsFinancialService.getAllSubDivisions() });

        if(filters.consultant){
            let consultantSearch = new ConsultantSearch();
            consultantSearch.onlyActives = false;
            consultantSearch.limit = 9999999;
            filters.consultant.list = this.dropdownItemFactory.build({source: await this.consultantService.searchConsultants(consultantSearch)});
            filters.consultant.options = this.dropdownSettingFactory.build({text:"Consultores"});
        }

        if(filters.responsible){
            filters.responsible.list = this.dropdownItemFactory.build({source:await this.userService.getAllUsersAsResponsibles()});
            filters.responsible.options = this.dropdownSettingFactory.build({text:"Gestores"});
        }

        if(filters.industries){
            filters.industries.list = this.dropdownItemFactory.build({source: await this.industriesService.getAll() });
            filters.industries.options = this.dropdownSettingFactory.build({ text: 'Setores'})
        }

        const centers = await this.excellenceCentersService.getAll();
        if(filters.excellenceCenters){
            filters.excellenceCenters.list = this.dropdownItemFactory.build({source: centers.filter(c => c.type == 1) });
            filters.excellenceCenters.options = this.dropdownSettingFactory.build({ text: 'Centros de Excelência'})
        }

        if(filters.supportCenter){
            filters.supportCenter.list = this.dropdownItemFactory.build({source: centers.filter(c => c.type == 2) });
            filters.supportCenter.options = this.dropdownSettingFactory.build({ text: 'Áreas de Suporte'})
        }

        filters.divisions.list = this.optionsBilling.division;
        filters.status.list = this.optionsBilling.status;


        filters.owners.options = this.dropdownSettingFactory.build({ text: 'Requisitantes' });
        filters.companies.options = this.dropdownSettingFactory.build({ text: 'Clientes' });
        filters.divisions.options = this.dropdownSettingFactory.build({ text: 'Divisões' });
        filters.status.options = this.dropdownSettingFactory.build({ text: 'Status' });
        filters.subDivision.options = this.commonHelper.getDropDownSettings(false, 'Tipos de Serviços', false, 'Marcar todos os Tipos de Serviços', 'Desmarcar todos os Tipos de Serviços', true,null, '');
        filters.projects.options = this.dropdownSettingFactory.build({ text: 'Projetos' })
        const filtersStored = this.localStorage.retrieve(localStorageFilterKey);
        return filtersStored ? this.loadStored(filters, filtersStored) : filters;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/cost/filters.factory.ts